import api from './api';
import {mapWorkingTimeDto} from '../dto/WorkingTimeDTO';

export const getAllWorkingTime = async () => {
    try {
        const res = await api.get('/WorkingTimeRules');
        console.log(res);
        console.log(res.data.map(mapWorkingTimeDto));
        return res.data.map(mapWorkingTimeDto);
    } catch (err) {
        console.error("Error adding working time:", err);
        throw err;
    }
}

export const addWorkingTime = async ({user_id, valid_from, valid_until, weekday, expected_hours}) => {
    try {
        const res = await api.post('/WorkingTimeRules', {
            user_id, valid_from, valid_until, weekday, expected_hours
        });
        return res.data;
    } catch (err) {
        console.error("Error adding working time:", err);
        throw err;
    }
};

export const deleteWorkingTime = async (id) => {
    try {
        const res = await api.delete(`/WorkingTimeRules/${id}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting working time:", err);
        throw err;
    }
}

export const changeWorkingTime = async (ruleId, {valid_from, valid_until, weekday, expected_hours}) => {
    try {
        const res = await api.patch(`/WorkingTimeRules/${ruleId}`, {
            valid_from, valid_until, weekday, expected_hours
        });
        return res.data;
    } catch (err) {
        console.error("Error changing working time:", err);
        throw err;
    }
};
